import HTTP from "../../../services/HTTP.js";
// fetch Users
export const getUsers = async () => {
  const res = await HTTP.get('/users');
  return res.data;
};
export const getUserById = async (_id) => {
  const res = await HTTP.get(`/users/${_id}`);
  return res.data;
};
// fetch Managers
export const getManagers = async () => {
  const res = await HTTP.get('/users/managers');
  return res.data;
};

// fetch Users
export const getStaffs = async () => {
  const res = await HTTP.get('/users/staffs');
  return res.data;
};
// fetch assistant super admn
export const getAssistantSuperAdmin = async () => {
  const res = await HTTP.get('/users/assistant-superadmin');
  return res.data;
};

// add user
export const addUser = async (userData) => {
  const res = await HTTP.post('users/add', userData);
  return res.data;
};

// update password
export const updateUser = async (data) => {
  const res = await HTTP.put('users/update', data);
  return res.data;
};
// delete password
export const deleteUser = async (id) => {
  const res = await HTTP.delete(`users/delete/${id}`);
  return res.data;
};


// fetch Managers by user id
export const getManagersByUser = async (id) => {
  const res = await HTTP.get(`/users/managers/${id}`);
  return res.data;
};

// fetch Staffs by user id
export const getStaffsByUser = async (id) => {
  const res = await HTTP.get(`/users/staffs/${id}`);
  return res.data;
};